import React, { useCallback, useEffect, useMemo, useState } from "react";

import { DynamicPager } from "../../components/Pager/Dynamic/DynamicPager";

const useDynamicPager = ({
    items = [],
    itemsPerPage = 1,
    elementToScroll = ""
}) => {
    const [page, setPage] = useState(1);

    const pagedItems = useMemo(() => {
        return [...items.slice((page - 1) * itemsPerPage, page * itemsPerPage)];
    }, [items, itemsPerPage, page]);

    useEffect(() => {
        setPage(1);
    }, [items]);

    const onSetPage = useCallback(
        (newPage) => {
            setPage(newPage);
            document.getElementById(elementToScroll)?.scrollIntoView();
        },
        [elementToScroll]
    );

    const lastPage = Math.ceil(items.length / itemsPerPage);

    return {
        currentPage: page,
        lastPage,
        pagedItems,
        onSetPage,
        Component: (props) => (
            <DynamicPager
                currentPage={page}
                onSetPage={onSetPage}
                lastPage={lastPage}
                {...props}
            />
        )
    };
};

export { useDynamicPager };
